//#region Imports
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { DashboardService } from '@core/http/services';
import * as fromActions from '../actions';
import * as fromMappings from '@core/mappings';
import * as fromModel from '@shared/models';
//#endregion

@Injectable()
export class DashboardEffects {
    loadClients$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.GET_DASHBOARD_DATA),
            mergeMap((props: { searchQuery }) =>
                this.dashboardService.getDashboard(props.searchQuery).pipe(
                    map((data: any) => {
                        console.log(`data`);
                        console.log(data);

                        return fromActions.GET_DASHBOARD_DATA_SUCCESS({ dashData: data.msg });
                    }),
                    catchError((error: Error) => {
                        return of(
                            fromActions.GET_DASHBOARD_DATA_FAIL({
                                error: fromMappings.ToError(error)
                            })
                        );
                    })
                )
            )
        )
    );
    //#endregion

    constructor(private actions$: Actions, private dashboardService: DashboardService) {}
}
